export class MapSettings{
    displayLegendChecked = true;
    displayOddRampsChecked = true;
    displayEvenRampsChecked = true;
    displayWingsChecked = true;
    displayPOIChecked = true;
}